import { TrendLabel } from '@/api/rest/resources/conservation';
import { IndicatorFactType } from '@/api/rest/resources/types/fact';
import { useOrganizationIndicatorReportingFact } from '@/pages/shared/hooks/useOrganizationFact';
import { usePlotFacts } from '@/pages/shared/hooks/usePlotFact';
import { getFactFromFactArray } from '@/pages/shared/hooks/utils';
import { isNullish } from '@/utils/booleans';

const THRESHOLD = 1;

export const useTrendLabelFromOrganizationFact = ({ fact }: { fact: IndicatorFactType }): TrendLabel | null => {
  const { [fact]: factData } = useOrganizationIndicatorReportingFact<number>(fact);
  const factValue = factData?.value;

  if (isNullish(factValue) || typeof factValue !== 'number') {
    return null;
  }

  if (factValue >= THRESHOLD) {
    return TrendLabel.increasing;
  }

  if (factValue <= -THRESHOLD) {
    return TrendLabel.decreasing;
  }

  return TrendLabel.stable;
};

export const useTrendLabelFromPlotFact = ({ fact }: { fact: IndicatorFactType }): TrendLabel | null => {
  const facts = usePlotFacts<number>([fact]);
  const factValue = getFactFromFactArray<number>(facts, fact)?.value;

  if (isNullish(factValue) || typeof factValue !== 'number') {
    return null;
  }

  if (factValue >= THRESHOLD) {
    return TrendLabel.increasing;
  }

  if (factValue <= -THRESHOLD) {
    return TrendLabel.decreasing;
  }

  return TrendLabel.stable;
};
